var e="\n    vDepth = getLinearDepth(localPos);\n";export{e as default};
